import { Text, Title, DetailText } from "../../components/units/Text"
// import { CommisionProps } from "../../components/Rest/Commission"
import { useSignedInContext } from "../../context/AuthContextProvider";
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { BoxWrapper } from "../../components/Wrappers/Wrappers";
import { updateCommissionData } from "../../components/Rest/accumulator/components/updateCommissionData";
import { fetchCommissionData } from "../../components/Rest/accumulator/components/fetchCommissionData";
// import { CommisionProps } from "../../components/Rest/accumulator/interfaces/commission";
import { CommisionProps } from "../../interfaces/Commission/types";
import { RestApiState } from "../../interfaces/Rest/types";
import { LgSuggestionFormInput } from "../../components/Form/components/SuggestionInput"
import { fetchModelName } from '../../components/Rest/accumulator/components/fetchModelName'
import { fetchAccumulatorElements } from "../../components/Rest/accumulator/components/fetchAccumulatorElements"
import { fetchAccumulatorContactors } from "../../components/Rest/accumulator/components/fetchAccumulatorContactors"
import { fetchAccumulatorActivities } from "../../components/Rest/accumulator/components/fetchAccumulatorActivities";
import { 
    fetchAdditionalEquipment, 
    fetchChargeConnectors , 
    fetchCurrentSensors, 
    fetchDischargeConnectors, 
    fetchExternalRemoteControls,
    fetchBmsModel
} from "../../components/Rest/accumulator/components/fetchAccumulatorEntities";
 

interface UpdateCommissionProps {
    commission: {
        data: CommisionProps | null;
        changes: Set<keyof CommisionProps>;
        requestState: RestApiState;
        timeOutId: NodeJS.Timeout | null;
    }
}


const defaultUpdateCommissionState = { commission:{
    data: null,
    changes: new Set<keyof CommisionProps>(['is_cooling_activity', 'is_heating_activity', 'is_default_activity', 'is_waterproof_activity']),
    requestState: RestApiState.Idle,
    timeOutId: null

}}


function submitClassHandler(status: RestApiState): string {
    // Defines css class based on status
    if (status === RestApiState.Success) {
        return "submit-btn-success"
    }

    if (status !== RestApiState.Idle)  {
        return 'submit-btn disabled'
    }

    return "bg-secondary text-light"
}


export const SetCommissionProps = () => {
    const { user } = useSignedInContext()
    const { serial_number } = useParams()

    const [commissionProps, setProps] = useState<UpdateCommissionProps>(defaultUpdateCommissionState)

    if (serial_number === undefined) {
        throw new Error("Serial number must be provided as parameter");
    }

    useEffect(() => {
        async function myFunction() {
            if (commissionProps.commission.requestState !== RestApiState.Idle) {
                updateRestApiStatus(RestApiState.Idle);
            }
        }

        if (commissionProps.commission.timeOutId !== null) {
            clearTimeout(commissionProps.commission.timeOutId)
        }

        if (commissionProps.commission.requestState !== RestApiState.Pending && commissionProps.commission.requestState !== RestApiState.Idle) {
            let timeOut = setTimeout(myFunction, 1500);
            setProps((prev) => ({
                ...prev,
                commission: {
                    ...prev.commission,
                    timeOutId: timeOut, // Update the requestState field
                },
            }));
        }

    }, [commissionProps.commission.requestState])

    const statusText = ():string => {
        let text = ''
        switch(commissionProps.commission.requestState) {
            case RestApiState.Idle : text = "" ; break;
            case RestApiState.Pending : text = "Обновляется"; break;
            case RestApiState.Success : text = "Обновлено"; break;
            case RestApiState.BadRequest : text = "Заполните поля"; break;
            case RestApiState.ServerError : text = "Ошибка сервера"; break;
            case RestApiState.Unknown : text = "Неизвестная ошибка"; break;
            default: text = "..."; break;
        }
        return text
    }

    const setCommissionData = (newData: typeof commissionProps.commission.data): void => {
        setProps(prev => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: newData,
            },
        }));
    }


    const updateDataValue = (e: React.ChangeEvent<HTMLInputElement>):void => {
        const { name, value } = e.target;
        const key = name as keyof CommisionProps;
        setProps((prev) => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: prev.commission.data
                ? { ...prev.commission.data, [key]: value }
                : null,
            },
        }));
        
        setProps((prevState) => {
            const updatedChanges = new Set(prevState.commission.changes); // Clone the current Set
            updatedChanges.add(key); // Add the new key
            return {
                ...prevState,
                commission: {
                    ...prevState.commission,
                    changes: updatedChanges, // Update changes with the new Set
              },
            };
        });
    };

    const updateRestApiStatus = (status: RestApiState) => {
        setProps((prev) => ({
            ...prev,
            commission: {
                ...prev.commission,
                requestState: status, // Update the requestState field
            },
        }));
    }

    useEffect(() => {
        const fetchSectionData = async () => {
            
            const response = await fetchCommissionData(serial_number, user.role_slug)
            if (response) {
                setCommissionData(response)
            } 
        }
        fetchSectionData()
    }, [])

    const handelSubmit = (e: any) => {
        e.preventDefault();
        if (commissionProps.commission.data === null) {
            throw new Error("Commission cant be empty");
        }
        const dict: Partial<Record<keyof CommisionProps, any>> = {};
        commissionProps.commission.changes.forEach((key) => {
            if (key === 'documentations') {
                return
            }
            dict[key] = commissionProps.commission.data?.[key];
        });

        updateCommissionData(serial_number, user.role_slug, dict as Record<string, unknown>, updateRestApiStatus)
    }
    
    return (
        <div className='content-wrapper flex-grow acb-dashboard-wrapper show-up'>
            <DetailText href={`/react/acb/detail/${serial_number}`}>
                    Назад
            </DetailText>
            <br />
            <br />
            <Title className="dispaly-block">{serial_number}</Title>
            <br />
            <BoxWrapper bg="bg-primary" p="p3" r="r15">
                <Text size="lg" className="bold dispaly-block">Форма ввода данных справочников</Text>
                <br />
                {commissionProps.commission.data ? (
                    <form onSubmit={handelSubmit} className="organization-form">
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Исполнение</Text>
                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_activity} 
                                label='Исполнение' 
                                name='accumulator_activity' 
                                type='text' 
                                required={false}
                                valueSetter={updateDataValue} 
                                fetchSuggestion={fetchAccumulatorActivities}
                            />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Прочее</Text>
                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_element} 
                                label='Тип элементов' 
                                name='accumulator_element' 
                                type='text' 
                                required={false}
                                valueSetter={updateDataValue} 
                                fetchSuggestion={fetchAccumulatorElements}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_model_name} 
                                label='Серия АКБ' 
                                name='accumulator_model_name' 
                                type='text' 
                                required={false}
                                valueSetter={updateDataValue} 
                                fetchSuggestion={fetchModelName}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_contactor} 
                                label='Тип контакторов' 
                                name='accumulator_contactor' 
                                type='text' 
                                required={false}
                                valueSetter={updateDataValue} 
                                fetchSuggestion={fetchAccumulatorContactors}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_bms_model} 
                                label='Модель BMS' 
                                name='accumulator_bms_model' 
                                type='text' 
                                required={false}
                                valueSetter={updateDataValue} 
                                fetchSuggestion={fetchBmsModel}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_additional_equipment}
                                label='Доп. оборудование'
                                name='accumulator_additional_equipment'
                                type='text'
                                required={false}
                                valueSetter={updateDataValue}
                                fetchSuggestion={fetchAdditionalEquipment}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_discharge_connector}
                                label='Разъем разряда'
                                name='accumulator_discharge_connector'
                                type='text'
                                required={false}
                                valueSetter={updateDataValue}
                                fetchSuggestion={fetchDischargeConnectors}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_charge_connector}
                                label='Разъем заряда'
                                name='accumulator_charge_connector'
                                type='text'
                                required={false}
                                valueSetter={updateDataValue}
                                fetchSuggestion={fetchChargeConnectors}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_current_sensor}
                                label='Датчик тока'
                                name='accumulator_current_sensor'
                                type='text'
                                required={false}
                                valueSetter={updateDataValue}
                                fetchSuggestion={fetchCurrentSensors}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_external_remote_control}
                                label='Внешний пульт'
                                name='accumulator_external_remote_control'
                                type='text'
                                required={false}
                                valueSetter={updateDataValue}
                                fetchSuggestion={fetchExternalRemoteControls}
                            />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <button 
                                type="submit"
                                disabled={ commissionProps.commission.requestState !== RestApiState.Idle }
                                className={`${submitClassHandler(commissionProps.commission.requestState)} p2 bold` }
                                style={{position:'relative', width: '100%', borderRadius: '5px', outline:'none', border: 'none'}}
                                >
                                { commissionProps.commission.requestState === RestApiState.Idle && <Text  className="slide-bottom-to-top">Сохранить</Text>  }
                                { commissionProps.commission.requestState === RestApiState.Pending && <Text className="slide-bottom-to-top">{ <div className="btnloader"></div> }</Text>}
                                { (commissionProps.commission.requestState !== RestApiState.Pending && commissionProps.commission.requestState !== RestApiState.Idle) && <Text className="slide-bottom-to-top">{ statusText() }</Text>} 
                            </button>
                        </div>
                    </form>
                ) : (
                    <h1>Loading...</h1>
                )}
            </BoxWrapper>

        </div>
    )
}